import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RoomModel } from '../models/room.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoomService {
  private backUrl = `${environment.apiUrl}api/room`;

  constructor(private http: HttpClient) {
  }

  get(): Observable<RoomModel[]> {
    return this.http.get<RoomModel[]>(`${this.backUrl}`);
  }

  getAvailableRooms(checkInDate: any, checkOutDate: any, reservationId: any): Observable<RoomModel[]> {
    let query = reservationId ? `&reservationId=${reservationId}` : '';
    return this.http.get<RoomModel[]>(`${this.backUrl}/getAvailableRooms?checkInDate=${checkInDate}&checkOutDate=${checkOutDate}${query}`);
  }

  post(model: RoomModel): Observable<any> {
    return this.http.post(`${this.backUrl}`, model);
  }

  put(model: RoomModel): Observable<any> {
    return this.http.put(`${this.backUrl}/${model.id}`, model);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.backUrl}/${id}`);
  }
}
